import {
  Box,
  dropDetails,
  Heading,
  NextImage,
  Text,
} from '@dapperlabs/core-fe';
import { isFuture, parseISO } from 'date-fns';
import i18next from 'i18next';
import { useState } from 'react';
import { useTranslation } from 'src/lib/translations';
import { PackPriceLabel } from 'src/modules/PackDetailsPage';
import { TimerText } from 'src/modules/PackDetailsPage/components/RowTexts/TimerText';

import { isOngoing } from '../helpers';
import { DistributionExtended } from '../types';
import { CTAButton } from './CTAButton';

interface Props {
  distribution: DistributionExtended;
}

export const ActiveDropSinglePack = ({ distribution }: Props) => {
  const { t } = useTranslation();
  const [globalLanguage, setGlobalLanguage] = useState(i18next.language);

  i18next.on('languageChanged', (lang) => {
    setGlobalLanguage(lang);
  });

  const description = JSON.parse(
    distribution.description.replaceAll('\n', '\\n'),
  );

  const isDropUpcoming = isFuture(parseISO(distribution.startTime));
  const isDropOngoing = isOngoing(distribution.startTime, distribution.endTime);

  let CTALabel = 'UpcomingDrops.PackDropButtonText';
  if (isDropOngoing) {
    CTALabel = 'Drops.BuyNowLabel';
  } else if (isDropUpcoming) {
    CTALabel = 'PackDetail.QueueState.BtnLabel.WaitroomOpen';
  }

  return (
    <Box
      as='section'
      alignItems='flex-start'
      flexDirection={{ base: 'column', md: 'row' }}
      gap={{ base: 10, lg: 20 }}
      display='flex'
      mb={14}
      mx={{ base: 4, lg: 24 }}
      pt={{ base: 8, md: 16 }}
    >
      <Box
        position='relative'
        alignItems='center'
        justifyContent='center'
        display='flex'
        width='100%'
        height='400px'
      >
        <Box flex='0 1 auto'>
          <NextImage
            width='640px'
            height='640px'
            alt='pack image'
            src={distribution.images[0].url}
          />
        </Box>
      </Box>
      <Box
        flex='0 1 auto'
        width='100%'
        border='1px solid #393B45'
        borderRadius='12px'
        bgColor='black'
      >
        {distribution.startTime && isDropUpcoming && (
          <Box p={4} borderTopRadius='12px' bgColor='gray.800'>
            <TimerText
              drawTime={distribution.startTime}
              timerLabel={t('UpcomingDrops.DropTimerLabel')}
              timerNumberProps={{
                fontFamily: 'mono',
                fontWeight: 400,
              }}
              timerUnitProps={{
                fontFamily: 'mono',
              }}
            />
          </Box>
        )}
        <Box p={4}>
          <Heading
            as='h1'
            mb={2}
            fontFamily='poster'
            fontSize={['5xl', '6xl']}
            fontWeight='500'
          >
            {distribution.title}
          </Heading>
          <Text mb={6} fontSize={['sm', 'md']} variant='body'>
            {description[globalLanguage]}
          </Text>

          <PackPriceLabel hasFrom priceTag={distribution.price.value} />
          <Box mt={6} pb={4}>
            <CTAButton
              href={dropDetails(distribution.id)}
              isDropOngoing={isDropOngoing}
              label={t(CTALabel)}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
